/** Naturals flow product releases (workspace service menus + salon catalog). */

export const NATURALS_FLOW_CURRENT_VERSION = "V.1.0";

/** Keep in sync with docs/naturals-flow/V.1.0.md */
export const NATURALS_FLOW_RELEASE_NOTES = [
  {
    version: "V.1.0",
    date: "2026-10-23",
    title: "Service menus, rate-card import, and salon catalog",
    meta: [
      "Platform git tag: v1.29.0",
      "Naturals Workspace + Salon kiosk",
      "Re-import rate cards after deploy to refresh categories and prices",
    ],
    sections: [
      {
        heading: "Added",
        items: [
          "Workspace Service management: import PDF, Excel, and Word lists with preview and commit.",
          "Separate men's and women's service lists with gender stamped on import.",
          "Salon service menu page with sidebar categories, browse-only cards, and lobby entry.",
          "Ask a stylist card on the catalog routes to stylist check-in.",
        ],
      },
      {
        heading: "Fixed & improved",
        items: [
          "Rate-card parser keeps services under PDF section categories and PDF page order.",
          "Page-break category continuation and hidden text-layer filtering on signature menus.",
          "Piercing member and non-member ranges (800 - 2000) with correct service names.",
          "Feet Treatment vs Heel Peel Treatment category assignment on men's signature cards.",
          "Import confirmation table order matches the PDF (not grouped by match status).",
        ],
      },
      {
        heading: "Changed",
        items: [
          "Import confirmation table: full width, scroll, sticky header; compact manual add row.",
          "Salon catalog gender switch: simple Women / Men text CTAs.",
        ],
      },
    ],
  },
];
